import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ImportedDocumentRenameFailedAction = {
	type: 'IMPORTED_DOCUMENT_RENAME_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ImportedDocumentRenameFailedAction => ({
	type: 'IMPORTED_DOCUMENT_RENAME_FAILED',
	payload,
});
